import React, { useEffect, useState } from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import axios from "axios";
import { BASE_URL } from "../../helper/api_helper";
import toast from "react-hot-toast";
import { Icon } from "@iconify/react/dist/iconify.js";

const MarketingNotifications = () => {
  const [notifications, setNotifications] = useState([]);
  const [isNotificationCreateOpen, setIsCreateNotification] = useState(false);
  const [isAlreadySent, setIsAlreadySent] = useState(false);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [isSend, setIsSend] = useState(true);
  const [scheduleDate, setScheduleDate] = useState("");
  const [focusedField, setFocusedField] = useState(null);
  const [cursorPos, setCursorPos] = useState(0);
  const [loading, setLoading] = useState(false);
  // const [createNotification, setIsCreateNotification] = useState(false);
  const [creatingNotification, setIsCreatingNotification] = useState(false);
  const [editNotification, setEditNotification] = useState(null);
  const handleEditNotification = (notification) => {
    setEditNotification(notification);
    setTitle(notification.title || "");
    setDescription(notification.description || "");
    setIsSend(notification.isSend);
    setScheduleDate(
      notification.send_time ? notification.send_time.slice(0, 16) : ""
    );
    setIsCreateNotification(true);
  };
  const variables = ["{{fullname}}"];
  const resetFields = () => {
    setTitle("");
    setDescription("");
    setIsSend(true);
    setScheduleDate("");
    setFocusedField(null);
    setCursorPos(0);
  };
  const insertVariable = (variable) => {
    if (focusedField === "title") {
      const before = title.slice(0, cursorPos);
      const after = title.slice(cursorPos);
      setTitle(before + variable + after);
    } else if (focusedField === "description") {
      const before = description.slice(0, cursorPos);
      const after = description.slice(cursorPos);
      setDescription(before + variable + after);
    }
  };
  const getSheduledNotifications = async () => {
    setLoading(true);
    try {
      let body = { isSend: isAlreadySent };
      let response = await axios.post(
        `${BASE_URL}/get-marketing-notifications`,
        body
      );
      if (response.status === 200) {
        setNotifications(response.data.data);
      }
    } catch (error) {
      toast.error(error.response.data.message);
      
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getSheduledNotifications();
  }, [isAlreadySent]);
  function formatDate(dateString) {
    const date = new Date(dateString);

    const day = String(date.getDate()).padStart(2, "0");
    const month = date.toLocaleString("default", { month: "long" });
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  }
  const handleCreateNotification = async () => {
    setIsCreatingNotification(true);
    try {
      if (!title) {
        toast.error("Please enter notification title");
        return;
      }
      if (!description) {
        toast.error("Please enter notification description");
        return;
      }
      if (isSend === false) {
        if (!scheduleDate) {
          toast.error("Please enter scheduled date");
          return;
        }
      }
      let body = {
        title: title,
        description: description,
        isSend: isSend,
        // send_time: scheduleDate,
      };
      if (isSend === false) {
        body.send_time = scheduleDate;
      }
      let response;
      if (editNotification && editNotification?.id) {
        // Edit mode
        response = await axios.put(
          `${BASE_URL}/update-marketing-notifications`,
          { ...body, id: editNotification?.id }
        );
      } else {
        // Create mode
        response = await axios.post(
          `${BASE_URL}/create-marketing-notifications`,
          body
        );
      }
      if (response.status === 200) {
        
        toast.success(
          editNotification
            ? "Notification Updated Successfully"
            : "Notification Created Successfully"
        );
        setIsCreateNotification(false);
        setEditNotification(null);
        getSheduledNotifications();
      resetFields();

      }
    } catch (error) {
      toast.error(error.response.data.message);
      
    } finally {
      setIsCreatingNotification(false);
      // setEditNotification(null);
    }
  };

  const handleDeleteNotification = async (user) => {
    const toastId = toast.loading("Deleting Notification...");
    try {
      const response = await axios.delete(
        `${BASE_URL}/delete-marketing-notification/${user?.id}`
      );
      if (response.status === 200) {
        toast.success("Notification deleted successfully", { id: toastId });
        getSheduledNotifications();
      }
    } catch (error) {
      toast.error(
        error.response?.data?.message || "Failed to delete Notification",
        { id: toastId }
      );
    }
  };


  const [showDescModal, setShowDescModal] = useState(false);
  const [descContent, setDescContent] = useState("");

  return (
    <MasterLayout>
      <Breadcrumb title="Marketing Notification" />

      <div className="col-lg-12">
        <div className="card">
          <div className="card-header py-16 pb-0 px-24 bg-base border border-end-0 border-start-0 border-top-0 d-flex align-items-center flex-wrap justify-content-between">
            <h6 className="text-lg mb-0">Marketing Notifications</h6>

            <div className="d-flex align-items-center gap-3">
              {" "}
              {/* Flex container for dropdown + button */}
              <div className=" overflow-hidden position-relative ">
                <div className="card-body " style={{ padding: "0px" }}>
                  <ul
                    className="nav focus-tab nav-pills"
                    id="pills-tab-two"
                    role="tablist"
                  >
                    <li className="nav-item" role="presentation">
                      <button
                        className={`nav-link fw-semibold text-primary-light radius-4 px-16 py-10 ${
                          isAlreadySent === false ? "active" : ""
                        }`}
                        type="button"
                        onClick={() => setIsAlreadySent(false)}
                      >
                        Scheduled
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button
                        className={`nav-link fw-semibold text-primary-light radius-4 px-16 py-10 ${
                          isAlreadySent === true ? "active" : ""
                        }`}
                        type="button"
                        onClick={() => setIsAlreadySent(true)}
                      >
                        Delivered
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
              <button
                type="button"
                className="btn btn-primary-600 radius-8 px-20 py-11"
                onClick={() => {
                  setIsCreateNotification(true);
                  setTitle("");
                  setDescription("");
                  setIsSend(true);
                  setScheduleDate("");
                }}
              >
                Create Notification
              </button>
            </div>
          </div>

          <div className="card-body">
            {loading ? (
              <div
                className="d-flex justify-content-center align-items-center"
                style={{
                  minHeight: "calc(100vh - 300px)",
                  width: "100%",
                  background: "transparent",
                }}
              >
                <div
                  className="spinner-border"
                  role="status"
                  style={{
                    color: "#243E85",
                    width: "3rem",
                    height: "3rem",
                  }}
                >
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            ) : notifications.length === 0 ? (
              <div
                className="d-flex justify-content-center align-items-center"
                style={{
                  minHeight: "200px",
                  width: "100%",
                  fontSize: "1.2rem",
                  color: "#243E85",
                  fontWeight: 500,
                }}
              >
                No notifications found.
              </div>
            ) : (
              <div className="table-responsive">
                <table className="table basic-border-table mb-0">
                  <thead>
                    <tr>
                      <th>Title</th>
                      <th>Description</th>
                      <th>Date</th>

                      {!isAlreadySent && <th>Action</th>}
                    </tr>
                  </thead>
                  <tbody>
                    {notifications?.map((items, index) => (
                      <tr key={index}>
                        {/* <td>{items?.title}</td> */}

                        <td>
                          {items?.title ? (
                            items.title.length > 30 ? (
                              <>
                                <span>{items.title.slice(0, 30) + "..."}</span>
                                <button
                                  className="btn btn-link  p-0 ms-2"
                                  style={{ color: "#243E85" }}
                                  onClick={() => {
                                    setDescContent(items.title);
                                    setShowDescModal(true);
                                  }}
                                >
                                  View more
                                </button>
                              </>
                            ) : (
                              <span>{items.title}</span>
                            )
                          ) : (
                            <span className="text-muted">
                              No title provided
                            </span>
                          )}
                        </td>
                        {/* <td>{items?.description}</td> */}

                        <td>
                          {items?.description ? (
                            items.description.length > 30 ? (
                              <>
                                <span>
                                  {items.description.slice(0, 30) + "..."}
                                </span>
                                <button
                                  className="btn btn-link  p-0 ms-2"
                                  style={{ color: "#243E85" }}
                                  onClick={() => {
                                    setDescContent(items.description);
                                    setShowDescModal(true);
                                  }}
                                >
                                  View more
                                </button>
                              </>
                            ) : (
                              <span>{items.description}</span>
                            )
                          ) : (
                            <span className="text-muted">
                              No description provided
                            </span>
                          )}
                        </td>
                        <td>{formatDate(items.send_time)}</td>

                        {!isAlreadySent && (
                          <td>
                            <span
                              // to={"/create-coupons"}
                              // onClick={()=> navigate(`/add-ship-charges/${shipCharge?.id}`)}
                              // onClick={() => dispatch(setSelectedCoupon(shipCharge))}
                              style={{ cursor: "pointer" }}
                              onClick={() => handleEditNotification(items)}
                              // onClick={() => handleEditUser(items)}
                              className="w-32-px h-32-px  me-8 bg-success-focus text-success-main rounded-circle d-inline-flex align-items-center justify-content-center"
                            >
                              <Icon icon="lucide:edit" />
                            </span>

                            {/* {items.isActive && */}
                            <span
                              style={{ cursor: "pointer" }}
                              onClick={() => handleDeleteNotification(items)}
                              className="w-32-px h-32-px me-8 bg-danger-focus text-danger-main rounded-circle d-inline-flex align-items-center justify-content-center"
                            >
                              <Icon icon="mingcute:delete-2-line" />
                            </span>

                            {/* } */}
                          </td>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>

      {isNotificationCreateOpen && (
        <div
          className=""
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1050,
          }}
        >
          <div className="modal-dialog modal-lg modal-dialog modal-dialog-centered">
            <div className="modal-content radius-16 bg-base">
              <div className="modal-header py-16 px-24 border border-top-0 border-start-0 border-end-0">
                <h1 className="modal-title fs-5" id="exampleModalLabel">
                  {editNotification
                    ? "Edit Marketing Notification"
                    : "Create Marketing Notification"}
                </h1>
                <button
                  type="button"
                  className="btn-close"
                  //   onClick={() => setIsCreateNotification(false)}
                  onClick={() => {
                    setIsCreateNotification(false);
                    setEditNotification(null);
                    resetFields();
                  }}
                  aria-label="Close"
                />
              </div>
              <div className="modal-body p-24">
                <form action="#">
                  <div className="row">
                    <div className="col-12 mb-20">
                      <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                        Title
                      </label>
                      <input
                        type="text"
                        className="form-control radius-8"
                        placeholder="Enter title"
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                        onFocus={(e) => {
                          setFocusedField("title");
                          setCursorPos(e.target.selectionStart);
                        }}
                        onClick={(e) => setCursorPos(e.target.selectionStart)}
                        onKeyUp={(e) => setCursorPos(e.target.selectionStart)}
                      />
                    </div>
                    <div className="col-12 mb-20">
                      <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                        Description
                      </label>
                      <textarea
                        type="text"
                        rows={5}
                        className="form-control radius-8"
                        placeholder="Enter description"
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                        onFocus={(e) => {
                          setFocusedField("description");
                          setCursorPos(e.target.selectionStart);
                        }}
                        onClick={(e) => setCursorPos(e.target.selectionStart)}
                        onKeyUp={(e) => setCursorPos(e.target.selectionStart)}
                      />
                    </div>
                    {focusedField && (
                      <div className="dropdown mt-2">
                        <label className="form-label fw-semibold text-sm mb-8">
                          Insert Variable
                        </label>
                        <select
                          className="form-control radius-8"
                          onChange={(e) => {
                            if (e.target.value) insertVariable(e.target.value);
                            e.target.selectedIndex = 0; // reset to placeholder
                          }}
                        >
                          <option value="">-- Select Variable --</option>
                          {variables.map((v, index) => (
                            <option key={index} value={v}>
                              {v}
                            </option>
                          ))}
                        </select>
                      </div>
                    )}
                    <div className="col-6 mb-20 mt-16">
                      <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                        Send Option
                      </label>
                      <div className="d-flex align-items-center flex-wrap gap-28">
                        <div className="form-check checked-success d-flex align-items-center gap-2">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="label"
                            id="Personal"
                            value="true"
                            checked={isSend === true}
                            onChange={() => setIsSend(true)}
                          />
                          <label
                            className="form-check-label line-height-1 fw-medium text-secondary-light text-sm d-flex align-items-center gap-1"
                            htmlFor="Personal"
                          >
                            <span className="w-8-px h-8-px bg-success-600 rounded-circle" />
                            Send Immediately
                          </label>
                        </div>
                        <div className="form-check checked-danger d-flex align-items-center gap-2">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="label"
                            id="Holiday"
                            value="false"
                            checked={isSend === false}
                            onChange={() => setIsSend(false)}
                          />
                          <label
                            className="form-check-label line-height-1 fw-medium text-secondary-light text-sm d-flex align-items-center gap-1"
                            htmlFor="Holiday"
                          >
                            <span className="w-8-px h-8-px bg-danger-600 rounded-circle" />
                            Schedule for Later
                          </label>
                        </div>
                      </div>
                    </div>
                    {isSend === false && (
                      <div className="col-6 mt-16">
                        <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                          Schedule Date & Time
                        </label>
                        <input
                          type="datetime-local"
                          className="form-control radius-8"
                          placeholder="Select schedule"
                          value={scheduleDate}
                          min={new Date().toISOString().slice(0, 16)}
                          onChange={(e) => setScheduleDate(e.target.value)}
                          onKeyDown={(e) => e.preventDefault()}
                        />
                      </div>
                    )}

                    <div className="d-flex align-items-center justify-content-center gap-3 mt-32">
                      <button
                        type="button"
                        onClick={() => {
                          setIsCreateNotification(false);
                          resetFields();
                        }}
                        className="border border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-40 py-11 radius-8"
                      >
                        Cancel
                      </button>
                      {/* <button
                        type="button"
                        onClick={handleCreateNotification}
                        className="btn btn-primary border border-primary-600 text-md px-48 py-12 radius-8"
                      >
                        Send
                      </button> */}

                      <button
                        type="button"
                        onClick={handleCreateNotification}
                        className="btn btn-primary border border-primary-600 text-md px-48 py-12 radius-8"
                        disabled={creatingNotification}
                      >
                        {creatingNotification ? (
                          <>
                            <span
                              className="spinner-border spinner-border-sm me-2"
                              role="status"
                              aria-hidden="true"
                              style={{ verticalAlign: "middle", color: "#fff" }}
                            ></span>
                            Sending...
                          </>
                        ) : (
                          "Send"
                        )}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}

      {showDescModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1050,
          }}
        >
          <div className="card" style={{ width: "90%", maxWidth: 600 }}>
            <div className="card-header d-flex justify-content-between align-items-center">
              <h6 className="mb-0">Message</h6>
              <button
                className="btn btn-sm btn-outline-secondary"
                onClick={() => setShowDescModal(false)}
              >
                Close
              </button>
            </div>
            <div className="card-body">
              {descContent ? (
                <p style={{ whiteSpace: "pre-wrap" }}>{descContent}</p>
              ) : (
                <p className="text-muted">No description provided</p>
              )}
            </div>
          </div>
        </div>
      )}
    </MasterLayout>
  );
};

export default MarketingNotifications;
